// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bhn_h bhn_kh bhn_we bhn_su bhn_vt bhn_sw bhn_sn"};